import React from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { useDeviceLayout } from '@vio/atlas/context/deviceLayout';
import { Text } from '@vio/atlas/Text';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import UnifiedDateTime from '../../../utils/UnifiedDateTime';
interface Props {
  expiresAt?: string;
}
const HeaderContentWrapper = /*#__PURE__*/styled('div')({
  name: "HeaderContentWrapper",
  class: "h1ydoui",
  propsAsIs: false
});
export const HeaderContent = ({
  expiresAt
}: Props) => {
  const {
    isMobile
  } = useDeviceLayout();
  return <HeaderContentWrapper className={cx(isMobile && '__isMobile')}>
      <Text colorPath="content.highlight.c500" variant="titleXL">
        <FormattedMessageWrapper id="dealFreeze.confirmationOverlayHeader" defaultMessage="Deal secured!" />
      </Text>

      {expiresAt && <Text variant="bodyM" colorPath="content.neutral.c000" align="center">
          <FormattedMessageWrapper id="dealFreeze.confirmationOverlaySubHeader" defaultMessage="The price and availability are now guaranteed until <br></br> {expirationDate}. Book when you’re ready." values={{
        expirationDate: <UnifiedDateTime value={expiresAt} format={'date-longform'} />,
        br: () => <br />
      }} />
        </Text>}
    </HeaderContentWrapper>;
};

require("./HeaderContent.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./HeaderContent.tsx");